"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var GALLERY_SIZE_TYPE = {
  SMART: 'smart',
  PIXELS: 'px',
  RATIO: 'ratio'
};
var _default = GALLERY_SIZE_TYPE;
exports["default"] = _default;